import { GroupEndInstructionContainer } from "../containers/GroupEndInstructionContainer"

export const GroupInstructionsEndPage = () => (
    <GroupEndInstructionContainer/>
)